import Radio from './radio';
import RadioGroup from './radio-group';
var DefaultRadio = Radio;
DefaultRadio.Group = RadioGroup;
export default DefaultRadio;
//# sourceMappingURL=index.js.map